/**
 * "Colegas mandam para mim": whether teammates who share a team with you may send your agents work — an analysis, an
 * audit, a step of team work. **Off by default** (the owner, 29/10/2026; docs/refactor/63): Vephus is a door into the
 * person's computer, and nobody may receive a command they did not ask for. Switching on asks who you are again, as
 * switching remote commands on does; switching off is immediate and withdraws what teammates already sent. In
 * Configurações › Conta (always there), in the left menu's Acesso rápido and in Agentes › Comandos remotos.
 */

import { Users } from 'lucide-react'
import { useI18n } from '../lib/i18n'
import { useTeamWorkToggle } from '../lib/teamWorkToggle'
import { Panel } from './primitives'

export function TeamWorkSwitch({ accepting }: { accepting: boolean }) {
  const { t } = useI18n()
  const { set, dialog } = useTeamWorkToggle()

  return (
    <Panel title={<span className="row row--tight"><Users size={16} aria-hidden /> {t('team.switchTitle')}</span>}>
      <div className="row row--between row--wrap">
        <p className="small muted" style={{ margin: 0, maxWidth: 620 }}>{t('team.switchBody')}</p>
        <label className="row row--tight small">
          <input type="checkbox" checked={accepting} disabled={set.isPending} onChange={(e) => set.mutate(e.target.checked)} />
          {t('team.switchLabel')}
        </label>
      </div>
      {dialog}
    </Panel>
  )
}
